const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaseManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    className: "appointment-types__type-svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.42 37.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21.21,
    cy: 27.14,
    r: 3.54,
    style: {
      fill: "none",
      stroke: "#9d9c9c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.57125270366669px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.28,37v-2a3.54,3.54,0,0,0-3.53-3.53H17.68a3.54,3.54,0,0,0-3.54,3.53v2Z",
    style: {
      fill: "none",
      stroke: "#9d9c9c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.57125270366669px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.57,
    cy: 9.07,
    r: 3.54,
    style: {
      fill: "none",
      stroke: "#9d9c9c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.57125270366669px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.64,18.89v-2a3.54,3.54,0,0,0-3.54-3.53H31a3.54,3.54,0,0,0-3.53,3.53v2Z",
    style: {
      fill: "none",
      stroke: "#9d9c9c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.57125270366669px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.86,
    cy: 9.07,
    r: 3.54,
    style: {
      fill: "none",
      stroke: "#9d9c9c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.57125270366669px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.93,18.89v-2a3.54,3.54,0,0,0-3.54-3.53H4.32A3.54,3.54,0,0,0,.79,16.85v2Z",
    style: {
      fill: "none",
      stroke: "#9d9c9c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.57125270366669px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.93,32.44h0a0,0,0,0,1,0-.06A17.21,17.21,0,0,0,38,22s0,0,0,0,0,0,0,.05A17.3,17.3,0,0,1,31,32.44Z",
    className: "appointment-types__type-svg-stroke",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.57125270366669px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,32.44h0A17.3,17.3,0,0,1,4.34,22.05s0-.05,0-.05a0,0,0,0,1,0,0,17.18,17.18,0,0,0,7.1,10.34s0,0,0,.06Z",
    className: "appointment-types__type-svg-stroke",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.57125270366669px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.74,3.69s0,0,0,0a0,0,0,0,1,0,0,17.33,17.33,0,0,1,19,0s0,0,0,0,0,0-.06,0a17.19,17.19,0,0,0-18.9,0Z",
    className: "appointment-types__type-svg-stroke",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.57125270366669px"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseManagement);
export default __webpack_public_path__ + "static/media/case_management.5b4255f19c0e429d19a8e14a27a5277b.svg";
export { ForwardRef as ReactComponent };